/* eslint-disable react-hooks/exhaustive-deps */
import { useRef, useEffect } from 'react';
import isDeepEqualReact from 'fast-deep-equal/react';

const useWatchUpdateEffect = (effect, deps) => {
	const isFirst = useRef(true);
	const depsList = useRef(undefined);
	const isFirstUpdate = isFirst.current;

	if (!depsList.current || !isDeepEqualReact(deps, depsList.current)) {
		depsList.current = deps;
	}

	useEffect(() => {
		if (!isFirstUpdate) {
			return effect();
		}
		return () => {};
	}, depsList.current);

	if (isFirst.current) {
		isFirst.current = false;
	}
};

export default useWatchUpdateEffect;
